import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/fanhui_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-ddbdeb0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "coverBox",
  style: {"height":"220px"}
}
const _hoisted_2 = { class: "navBar" }
const _hoisted_3 = { class: "namebox" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px","width":"30px"} }, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "matchInfo" }
const _hoisted_8 = { class: "scores" }
const _hoisted_9 = { class: "timeName" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "type" }
const _hoisted_12 = { class: "num" }
const _hoisted_13 = { class: "scores" }
const _hoisted_14 = { class: "timeName" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" <van-icon name=\"arrow-left\" size=\"30\" color=\"#fff\" class=\"back\" @click=\"backRouter\" /> "),
      _createElementVNode("img", {
        class: "banckimg",
        src: _imports_0,
        onClick: $setup.backRouter,
        alt: ""
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.data.short_name_zh), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_5, _toDisplayString($setup.formatDateTime($setup.data.match_time)), 1 /* TEXT */)
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_van_image, {
          round: "",
          width: "50px",
          height: "50px",
          src: $setup.data.home_log
        }, null, 8 /* PROPS */, ["src"]),
        _createElementVNode("div", _hoisted_9, _toDisplayString($setup.data.home_name), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString($setup.getStatus()), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_12, _toDisplayString($setup.Match.getHomeScore($setup.data)) + " - " + _toDisplayString($setup.Match.getAwayScore($setup.data)), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_van_image, {
          round: "",
          width: "50px",
          height: "50px",
          src: $setup.data.away_log
        }, null, 8 /* PROPS */, ["src"]),
        _createElementVNode("div", _hoisted_14, _toDisplayString($setup.data.away_name), 1 /* TEXT */)
      ])
    ])
  ]))
}